import { MenuItem, Paper, Select, TextField } from '@mui/material'
import styled from 'styled-components'

interface ContentParamsFiltersProps {
  onlyOne?: boolean
}

export const ContentParamsBody = styled.div`
  width: 100%;
  border-top: 1px solid ${(props) => props.theme.colors.grayBorder};
  padding-top: 30px;
  margin-top: 8px;
  padding-bottom: 80px;
`

export const ContentParams = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-top: 22px;
  width: 100%;
  border-color: ${(props) => props.theme.colors.grayBorder} !important;
`

export const ContentParamsSelect = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 8px 16px;
  background-color: ${(props) => props.theme.colors.grayBorder};
  border-radius: 8px;
  width: calc(100% - 32px);
`
export const ContentParamsSelectTitle = styled.div`
  font-size: 16px;
  font-weight: 700;
  line-height: 16px;
  color: #fff;
`

export const ContentParamsHeader = styled.div`
  display: flex;
  justify-content: space-between;

  & span {
    font-size: 16px;
    font-weight: 700;
    color: #fff;
  }
`

export const ContentParamsGroup = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(100% - 20px);
  background-color: ${(props) => props.theme.colors.grayDark};
  padding: 10px;
  border: 1px solid ${(props) => props.theme.colors.grayBorder};
  border-radius: 8px;
`

export const ContentParamsItem = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'onlyOne'
})<ContentParamsFiltersProps>`
  display: flex;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 0;
  border-bottom: 1px solid ${(props) => props.theme.colors.grayBorder};

  &:first-child {
    padding: ${(props) => (props.onlyOne ? '0' : '0 0 8px 0')};
  }

  &:last-child {
    padding: ${(props) => (props.onlyOne ? '0' : '8px 0 0 0')};
    border-bottom: none;
  }

  @media (max-width: 500px) {
    flex-direction: column;
  }
`

export const ContentParamsItemDetail = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 4px;
`

export const ContentParamsItemTitle = styled.span`
  display: flex;
  gap: 4px;
  align-items: flex-end;
  font-size: 14px;
  font-weight: 700;
  color: #fff;

  span {
    font-size: 12px;
    font-weight: 400;
    color: ${(props) => props.theme.colors.grayLight};
  }

  .required {
    font-size: 12px;
    color: ${(props) => props.theme.colors.red};
  }
`

export const ContentParamsItemDescription = styled.span`
  font-size: 12px;
  color: #fff;
`

export const ContentParamsItemInput = styled(TextField)`
  && {
    min-width: 140px;
    max-width: 140px;
    width: 140px;

    & .MuiOutlinedInput-root {
      border-radius: 8px;

      &:hover .MuiOutlinedInput-notchedOutline {
        border-color: ${(props) => props.theme.colors.grayLight};
      }
    }

    &.with-icon .MuiOutlinedInput-root {
      padding-left: 25px;
    }

    & .MuiOutlinedInput-notchedOutline {
      border: 1px solid ${(props) => props.theme.colors.grayLight};
    }

    & .Mui-focused .MuiOutlinedInput-notchedOutline {
      border: 2px solid ${(props) => props.theme.colors.grayLight};
    }

    & input {
      padding: 4px 8px;
      font-size: 12px;
      color: #fff;
    }

    @media (max-width: 500px) {
      max-width: 100%;
      width: 100%;
    }
  }
`

export const ContentParamsItemSelect = styled(Select)`
  && {
    border-radius: 8px;
    width: min-content;
    background-color: ${(props) => props.theme.colors.grayDark};

    & fieldset {
      border-color: ${(props) => props.theme.colors.grayLight} !important;
    }

    & .MuiSelect-select {
      padding: 4px 8px;
      font-size: 12px;
      color: ${(props) => props.theme.colors.grayLight};
    }

    & .MuiSelect-icon {
      color: ${(props) => props.theme.colors.grayLight};
    }
  }
`

export const ContentParamsItemSelectPaper = styled(Paper)`
  && {
    background: transparent;
    border-radius: 8px;

    & .MuiList-root {
      padding: 0;
      background-color: ${(props) => props.theme.colors.grayDark};
    }
  }
`

export const ContentParamsItemSelectMenuItem = styled(MenuItem)`
  && {
    background-color: ${(props) => props.theme.colors.grayDark};
    padding: 4px 10px;
    justify-content: center;
    font-size: 14px;
    color: #fff;
  }
`
